import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Pinterest(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.478 2 2 6.476 2 11.998c0 4.236 2.637 7.85 6.357 9.307-.085-.79-.166-2.006.037-2.867.18-.78 1.172-4.966 1.172-4.966s-.297-.6-.297-1.483c0-1.388.807-2.43 1.807-2.43.852 0 1.267.64 1.267 1.407 0 .856-.545 2.14-.83 3.326-.238.996.497 1.807 1.48 1.807 1.775 0 3.141-1.875 3.141-4.579 0-2.393-1.721-4.066-4.174-4.066-2.845 0-4.513 2.132-4.513 4.34 0 .862.329 1.781.744 2.282a.294.294 0 01.068.288c-.077.316-.244.996-.28 1.136-.045.185-.144.22-.334.136-1.248-.581-2.029-2.407-2.029-3.872 0-3.155 2.29-6.049 6.605-6.049 3.467 0 6.163 2.47 6.163 5.774 0 3.444-2.172 6.22-5.189 6.22-1.014 0-1.966-.527-2.29-1.15l-.623 2.376c-.226.87-.834 1.956-1.244 2.619.937.288 1.93.446 2.962.446 5.523 0 10-4.476 10-9.998 0-5.525-4.477-10.001-10-10.001V2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Pinterest);
export default ForwardRef;